import { useEffect, useState } from "react";

const useValidateModalForm = (errors, isSubmiting, onInvalid) => {
  const [validationModalOpen, setValidationModalOpen] = useState(false);

  useEffect(() => {
    handleValidateForm()
  }, [isSubmiting]);

  const handleValidateForm = () => {
    if (errors && Object.keys(errors).length > 0) {
      setValidationModalOpen(true);
      if (onInvalid) onInvalid(errors);
    }
  }

  const renderErrors = (errors) => {
    let list = Object.values(errors);

    let retorno = list.filter(i => typeof i != "object");

    let subforms = list.filter(i => typeof i == "object").map(item => {
      return item.map(i => {
        if( i !== undefined){
          return  Object.values(i)
        }
      })
    });

    subforms = [...Array().concat(...subforms)]

    let subformErrors = []

    subforms.forEach(val => {

      if( val !== undefined){
        return  subformErrors.push(...val);
      }
    });

    retorno.push(...subformErrors);

    return (
      <ul>
        {retorno.map(r => <li>{r}</li>)}
      </ul>
    )
  }

  return {
    handleValidateForm,
    renderErrors,
    validationModalOpen,
    setValidationModalOpen,
  }
}

export default useValidateModalForm;